import React, { Component } from 'react';
import { Button, Col,  Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import firebase from '../../../firebase.js';
import logo from '../../../assets/img/title-blue.png';
import LinkedinSDK from 'react-linkedin-sdk';

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      back: false,
      warning: "",
      info: "",
      isdisabled: false,
    };
    this.user_name = "";
    this.user_email = "";
    this.user_pwd1 = "";
    this.user_pwd2 = "";
    this.updateNameInput = this.updateNameInput.bind(this);
    this.updateEmailInput = this.updateEmailInput.bind(this);
    this.updatePWD1Input = this.updatePWD1Input.bind(this);
    this.updatePWD2Input = this.updatePWD2Input.bind(this);
    this.toggleSignUp = this.toggleSignUp.bind(this);
    this.toggleLogin = this.toggleLogin.bind(this);
    this.toggleFaceBookSignUp = this.toggleFaceBookSignUp.bind(this);
    this.toggleTwitterSignUp = this.toggleTwitterSignUp.bind(this);
    this.toggleGoogleSignUp = this.toggleGoogleSignUp.bind(this);
    console.log("dat");
  }

  saveUser2Db(user_name, user_email, userId) {

    let self = this;
    firebase.database().ref('/users/').once('value').then(function(snapshot) {
      let local_keys = [];
      let local_values = snapshot.val();
      if (snapshot.val()) {
        local_keys =  Object.keys(snapshot.val());
      }
      if(local_values[userId] !== undefined && local_values[userId]["image"] !== undefined) {
         localStorage.setItem("image_head",local_values[userId]["image"])
      }

      let dd = new Date()
      let month = dd.getMonth() < 10 ? "0" + (dd.getMonth() + 1).toString() : dd.getMonth() + 1;
      let day = dd.getDate() < 10 ? "0" + dd.getDate().toString() : dd.getDate();
      let hr = dd.getHours() < 10 ? "0" + dd.getHours().toString() : dd.getHours();
      let min = dd.getMinutes() < 10 ? "0" + dd.getMinutes().toString() : dd.getMinutes();
      let sec = dd.getSeconds() < 10 ? "0" + dd.getSeconds().toString() : dd.getSeconds();
      let timestamp = '' + dd.getFullYear() + month + day + hr + min + sec;

      firebase.database().ref('/codes/').once('value').then(function(snapshot) {
        let keys = [];
        if (snapshot.val()) {
          keys =  Object.keys(snapshot.val());
        }
        let freeCode = 0;
        freeCode = self.getAccessCode(keys, 4);
        let image = "";
        if(local_values[userId] !== undefined && local_values[userId]["image"] !== undefined) {
            image = local_values[userId]["image"]? local_values[userId]["image"]: "";
        }
        let createAt = "";
        if(local_values[userId] !== undefined && local_values[userId]["createAt"] !== undefined) {
          createAt = local_values[userId]["createAt"];
        } else {
          createAt = timestamp.toString();
        }
        
        let postData = {
          user_name: user_name,
          user_email: user_email,
          user_id : userId,
          createAt: createAt,
          updateAt: timestamp,
          role: 0,
          image: image,
          accessCode: freeCode,
          online: true,
          finalround: {
            enable: false
          }
        };

        let codeData = {
          used: true,
          user_email: user_email,
          user_id : userId,
        }

        var updates = {};
        if (local_keys === null) {
          //init
          updates['/users/' + userId] = postData;
          updates['/codes/' + freeCode] = codeData; 
          self.sendEmailWithCode(user_email, freeCode);
          firebase.database().ref().update(updates);
        }
        let isthere = local_keys.filter((key) => key === userId);
        if (!isthere || isthere.length === 0) {
          updates['/users/' + userId] = postData;
          updates['/codes/' + freeCode] = codeData; 
          self.sendEmailWithCode(user_email, freeCode);
          firebase.database().ref().update(updates);
        } else {
          updates['/users/' + userId + '/updateAt/' ] = timestamp;
          firebase.database().ref().update(updates);
        }

        // localStorage.setItem('user_id', userId.toString());
        // localStorage.setItem('user_name', user_name.toString());
        // localStorage.setItem('user_email', user_name.toString());
        // localStorage.setItem('image_head', image.toString());
        localStorage.removeItem('user_id');
        localStorage.removeItem('user_name');
        localStorage.removeItem('user_email');

        window.location = "/login";
      });
     
    });
  }
  

  sendEmailWithCode(email, code) {
    let to = "Client <" + email + ">";
    let text = "Your access code is " + code;
    fetch('https://api.smtp2go.com/v3/email/send', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "api_key": "api-ECC1D49AA46711E89D0AF23C91C88F4E",
        "to": [to],
        "sender": "Abiltar VR <info@icomputinglabs.in>",
        "subject": "Your Access Code",
        "text_body": text,
        "html_body": "<h1>" + text + "</h1>",
        })
        }).then(function(response) {
        return response.json();
        });
  }

  getAccessCode(keys, range) {
    let start = Math.pow(10, range - 1);
    let end = Math.pow(10, range) - 1;
    for (let i = start; i <= end; i++) {
      if (keys === undefined) {
        return i;
      }
      if (keys.indexOf(i.toString()) === -1) {
        return i;
      }
    }
  }

  toggleFaceBookSignUp() {
    let self = this;
    var provider = new firebase.auth.FacebookAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function(result) {
      var token = result.credential.accessToken;
      var user = result.user;
      console.log(user);
      console.log(token);
      console.log(user);
      let userId = firebase.auth().currentUser.uid;
      self.saveUser2Db(user.displayName, user.email, userId);
    }).catch(function(error) {
      console.log(error.message);
        self.setState({warning : error.code});
    });
  }

  toggleGoogleSignUp() {
    let self = this;
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function(result) {
      var token = result.credential.accessToken;
      var user = result.user;
      console.log(user);
      console.log(token);
      console.log(user);
      let userId = firebase.auth().currentUser.uid;
      self.saveUser2Db(user.displayName, user.email, userId);
      
    }).catch(function(error) {
        self.setState({warning : error.code});
    });
  }

  toggleTwitterSignUp() {
    let self = this;
    const provider = new firebase.auth.TwitterAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function(result) {
      var token = result.credential.accessToken;
      var user = result.user;
      console.log(user);
      console.log(token);
      console.log(user);
      let userId = firebase.auth().currentUser.uid;
      self.saveUser2Db(user.displayName, user.email, userId);
      
    }).catch(function(error) {
        self.setState({warning : error.code});
    });
  }

  toggleLogin() {
    window.location = "/login";
  }

  toggleSignUp() {
    console.log(this.user_name);
    console.log(this.user_email);
    console.log(this.user_pwd1);
    console.log(this.user_pwd2);
    this.setState({info : "Registering user. Please wait..."});
    if (this.user_email === "" || this.user_email === "" || this.user_pwd1 === "" || this.user_pwd2 === "") {
      this.setState({info : ""});
      this.setState({warning : "Please enter all the fields correctly."});
      return;
    }
    let self = this;
    if (this.user_pwd1 === this.user_pwd2) {
      firebase.auth().createUserWithEmailAndPassword(this.user_email, this.user_pwd2)
      .then(value => {
        let userId = firebase.auth().currentUser.uid;
        firebase.auth().currentUser.sendEmailVerification();
        firebase.auth().currentUser.updateProfile({
          displayName: self.user_name,
          photoURL: "",
        })
        self.saveUser2Db(self.user_name, self.user_email, userId);
      }).catch(e => {
        this.setState({info : ""});
        this.setState({warning : e.message});
      })
    } else {
      this.setState({info : ""});
      this.setState({warning : "Passwords do not match."});
    }

  }

  updateNameInput(evt) {
    this.user_name = evt.target.value;
    this.setState({warning : ""});
  }

  updateEmailInput(evt) {
    this.user_email = evt.target.value;
    this.setState({warning : ""});
  }

  updatePWD1Input(evt) {
    this.user_pwd1 = evt.target.value;
    this.setState({warning : ""});
  }

  updatePWD2Input(evt) {
    this.user_pwd2 = evt.target.value;
    this.setState({warning : ""});
  }

  responseLinkedin(response) {
    console.log(response)
  }
  
  render() {

    const responseLinkedin = response => {
      console.log(response)
    }
    return (
      <div className="app flex-row font-Poppins">

          <img alt="" src = {logo} className= "login-title" />
          <Row className="login header-100-vh-1">
            <Col className="login-col-a align-items-center login-col-width">
                <div className="login-div-a p-4">
                <h3 className="font-weight-400 mt-5 pt-5">Register</h3>
                  <br />
                  <br />
                  <h6 className="pb-2 color-red text-center">{this.state.warning}</h6>
                  <h6 className="pb-2 color-blue text-center">{this.state.info}</h6>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-user"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input disabled={this.state.isdisabled} id = "user_name" type="text"  onChange={ (e) => this.updateNameInput(e)} placeholder="Username" />
                  </InputGroup>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>@</InputGroupText>
                    </InputGroupAddon>
                    <Input disabled={this.state.isdisabled} type="text" id = "user_email" onChange={  (e) => this.updateEmailInput(e)} placeholder="Email" />
                  </InputGroup>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-lock"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input disabled={this.state.isdisabled} type="password" id = "user_pwd1" onChange={(e) =>this.updatePWD1Input(e)} placeholder="Password" />
                  </InputGroup>
                  <InputGroup className="mb-4">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-lock"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input disabled={this.state.isdisabled} type="password" id = "user_pwd2" onChange={(e) =>this.updatePWD2Input(e)} placeholder="Repeat password" />
                  </InputGroup>
                  <Button disabled={this.state.isdisabled} color="secondary" onClick={() => this.toggleSignUp()} className="login-text-color" block>Create Account</Button>
                  <h6 className="signup-back mt-3"> Already have an account? Login <Button onClick={() => this.toggleLogin()} color="link" className= "login-text-color-spec px-0 pb-2">Here</Button> </h6> 
                  <br />
                </div>
            </Col>
            <Col className="login-b">
            </Col>
          </Row>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/views/Pages/Register/Register.js